module.exports = __webpack_public_path__ + "static/media/product_18.8f3c9cf9.jpg";